import { FormGroup, FormControl, Validators, ValidationErrors, AbstractControl } from '@angular/forms';
import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fromEvent, Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface OtpDialogData {
  event$?: Subject<'success' | 'cancel' | 'reset'>;
}


@Component({
  selector: 'erbfactors-otp-dialog',
  templateUrl: './otp-dialog.component.html',
  styleUrls: ['./otp-dialog.component.scss'],
})
export class OtpDialogComponent implements OnInit {
  @Output() dialog_close: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('optInput', { static: false }) optInput: ElementRef;
  form: FormGroup;
  isConfirmDisabled: boolean = false;

  constructor(public dialogRef: MatDialogRef<OtpDialogComponent>) {}

  ngOnInit() {
    this.form = new FormGroup({
      otp: new FormControl(null, [
        Validators.required,
        this.fiveDigitIntegerValidator
      ]),
    });
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      if (this.form.valid) {
        this.close(true);
      } else {
        this.handleError();
      }
    }
  }

  close(confirm: boolean) {
    if (confirm && this.form.valid) {
      this.isConfirmDisabled = true; // Disable the button if submitted
      this.dialog_close.emit(this.form.get('otp').value);

    } else {
      this.dialog_close.emit('cancel');
    }
  }

  handleError() {
    this.form.reset();
    this.isConfirmDisabled = false; // Re-enable the button
  }


  private fiveDigitIntegerValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const isValid = /^\d{5,}$/.test(value);
    return isValid ? null : { invalidOtp: true };
  }
}
